import React from 'react';
import { StackedIcon } from 'ui/StackedIcon';
import SquareIcon from 'ui/Icons/tabler/square.component.svg';
import PlusIcon from 'ui/Icons/tabler/plus.component.svg';

export const PositiveIcon = (
  <StackedIcon
    BackgroundIcon={SquareIcon}
    ForegroundIcon={PlusIcon}
    backgroundClassName="w-8 h-8 fill-green-40"
    foregroundClassName="w-4 h-4 fill-transparent stroke-black stroke-2"
    stackDirection="overlay"
  />
);
